// Choix des couleurs
// https://paletton.com/#uid=13Z0u0kb3hI5Nrx8KmfdLc6kqb4
export const EraToGmMapping = [
  {
    era: 'NoAge',
    color: '#8d5858',
    gms: [
      'Temple_of_Relics', 'Observatory'
    ]
  },
  {
    era: 'Bronze',
    color: '#8D6A5C',
    gms: [
      'Statue_of_Zeus', 'Tower_of_Babel'
    ]
  },
  {
    era: 'IronAge',
    color: '#8D715C',
    gms: [
      'Lighthouse_of_Alexandria', 'Colosseum'
    ]
  },
  {
    era: 'Galata',
    color: '#8d775c',
    gms: [
      'Galata_Tower'
    ]
  },
  {
    era: 'EarlyMiddleAge',
    color: '#8D775C',
    gms: [
      'Cathedral_of_Aachen', 'Hagia_Sophia'
    ]
  },
  {
    era: 'HighMiddleAge',
    color: '#8D7C5C',
    gms: [
      'St_Mark_s_Basilica',
    ]
  },
  {
    era: 'Renaissance',
    color: '#8D805C',
    gms: [
      'Castel_del_Monte', 'Saint_Basil_s_Cathedral'
    ]
  },
  {
    era: 'ColonialAge',
    color: '#8D845C',
    gms: [
      'Deal_Castle', 'Frauenkirche_of_Dresden'
    ]
  },
  {
    era: 'IndustrialAge',
    color: '#8D8A5C',
    gms: [
      'Capitol', 'Royal_Albert_Hall'
    ]
  },
  {
    era: 'Progressive',
    color: '#838A5A',
    gms: [
      'Alcatraz', 'Chateau_Frontenac'
    ]
  },
  {
    era: 'Modern',
    color: '#818A5A',
    gms: [
      'Atomium'
    ]
  },
  {
    era: 'Postmodern',
    color: '#788557',
    gms: [
      'Cape_Canaveral', 'The_Habitat'
    ]
  },
  {
    era: 'Contemporary',
    color: '#637D52',
    gms: [
      'Innovation_Tower', 'Lotus_Temple'
    ]
  },
  {
    era: 'Tomorrow',
    color: '#5e774d',
    gms: [
      'Voyager_V1', 'Truce_Tower'
    ]
  },
  {
    era: 'Future',
    color: '#456A4F',
    gms: [
      'The_Arc', 'Rain_Forest_Project'
    ]
  },
  {
    era: 'ArcticFuture',
    color: '#395854',
    gms: [
      'Arctic_Orangery'
    ]
  },
  {
    era: 'OceanicFuture',
    color: '#3D4E5B',
    gms: [
      'The_Kraken', 'The_Blue_Galaxy'
    ]
  },
  {
    era: 'VirtualFuture',
    color: '#414B5E',
    gms: [
      'Terracotta_Army', 'Himeji_Castle'
    ]
  },
  {
    era: 'SpaceMars',
    color: '#454662',
    gms: [
      'The_Virgo_Project', 'Star_Gazer'
    ]
  },
  {
    era: 'SpaceAsteroidBelt',
    color: '#36364f',
    gms: [
      'Space_Carrier'
    ]
  },
  {
    era: 'SpaceVenus',
    color: '#1d1d29',
    gms: [
      'Flying_Island'
    ]
  },
  {
    era: 'SpaceJupiterMoon',
    color: '#14141e',
    gms: [
      'AI_Core'
    ]
  }, {
    // Tree line with "fake Era" for each GM because each of them have specific FP counts
    era: 'SpaceAgeTitan_Centaurus',
    color: '#1c0707',
    gms: [
      'Saturn_VI_Gate_CENTAURUS'
    ]
  }, {
    era: 'SpaceAgeTitan_Pegasus',
    color: '#1c0707',
    gms: [
      'Saturn_VI_Gate_PEGASUS'
    ]
  }, {
    era: 'SpaceAgeTitan_Hydra',
    color: '#1c0707',
    gms: [
      'Saturn_VI_Gate_HYDRA'
    ]
  }, {
    // Two line with "fake Era" for each GM because each of them have specific FP counts
    era: 'SpaceAgeSpaceHub_CosmicCatalyst',
    color: '#3c0606',
    gms: [
      'Cosmic_Catalyst'
    ]
  }, {
    era: 'SpaceAgeSpaceHub_StellarWarship',
    color: '#3c0606',
    gms: [
      'Stellar_Warship'
    ]
  }
]



// WEBPACK FOOTER //
// ./src/data/EraToGmMapping.js